import React from 'react';

const VarDisplay = ({ name, description, required, value }) => {
  const isSet = Boolean(value);
  return (
    <div className="flex items-center justify-between py-2 border-b">
      <div>
        <p className="font-mono text-sm text-gray-800">{name}</p>
        <p className="text-xs text-gray-500">{description}</p>
      </div>
      <div className="flex items-center">
        <span className={`text-xs font-medium mr-4 ${required ? 'text-gray-800' : 'text-gray-400'}`}>{required ? 'Required' : 'Optional'}</span>
        <span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${isSet ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
          {isSet ? 'Configured' : 'Missing'}
        </span>
      </div>
    </div>
  );
};

const serverVars = [
  'PROMPTLY_PASSWORD', 'NCB_API_KEY', 'DROPBOX_APP_KEY', 
  'DROPBOX_APP_SECRET', 'DROPBOX_REFRESH_TOKEN', 'OPENAI_SECRET_KEY'
];

function DebugPanel() {
  const frontendVars = [
    { name: "VITE_NCB_INSTANCE_ID", description: "NCB instance identifier", required: true, value: import.meta.env.VITE_NCB_INSTANCE_ID },
    { name: "VITE_DROPBOX_APP_KEY", description: "Dropbox application key (public)", required: true, value: import.meta.env.VITE_DROPBOX_APP_KEY },
  ];

  const systemInfo = {
    "Mode": import.meta.env.MODE,
    "Timezone": Intl.DateTimeFormat().resolvedOptions().timeZone,
    "Language": navigator.language,
    "Online": navigator.onLine ? 'Yes' : 'No',
    "User Agent": navigator.userAgent.substring(0, 50) + '...',
  };

  return (
    <div className="space-y-6">
      <div>
        <h3 className="font-bold text-lg text-gray-800 mb-2">Frontend Environment Variables</h3>
        <div className="bg-gray-50 p-4 rounded-lg border">
          {frontendVars.map(v => <VarDisplay key={v.name} {...v} />)}
        </div>
      </div>

      <div>
        <h3 className="font-bold text-lg text-gray-800 mb-2">Server-Only Secrets</h3>
        <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-3">
          <p className="text-sm text-yellow-800">These variables must be set as secrets in your Cloudflare Pages deployment. They are never exposed to the frontend.</p>
        </div>
        <div className="bg-gray-50 p-4 rounded-lg border">
          <ul className="list-disc list-inside text-sm font-mono text-gray-600">
            {serverVars.map(name => <li key={name}>{name}</li>)}
          </ul>
        </div>
      </div>

      <div>
        <h3 className="font-bold text-lg text-gray-800 mb-2">System Information</h3>
        <div className="bg-gray-50 p-4 rounded-lg border">
          {Object.entries(systemInfo).map(([key, value]) => (
            <div key={key} className="flex justify-between text-sm py-1">
              <span className="font-medium text-gray-600">{key}:</span>
              <span className="text-gray-800">{value}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default DebugPanel;